import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-manage-companion-account',
    templateUrl: './manage-companion-account.component.html',
    styleUrls: ['./manage-companion-account.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ManageCompanionAccountComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
